export default __webpack_public_path__ + "static/media/cloudIcon.16c9d817.svg";